import React from 'react'
import _ from 'lodash';
import { withStyles, Typography, TextField } from '@material-ui/core';

const styles = {
    subHeader: {
        color: '#878787',
        flex: 1
    },
    containerLabelsFullWidth: {
        display: 'flex'
    },
    formFields: {
        display: 'inline',
        margin: '0 0 10px 0px',
        height: '45px',
        marginBottom: '7px',
        marginTop: '7px',
    },
};

const noop = () => { };

/**
 * @typedef {Object} ReactTextFieldProps
 * @property {Function=} ReactTextFieldProps.changeHandler
 * @property {number=} ReactTextFieldProps.inputLength
 * @property {string} ReactTextFieldProps.valueString
 * @property {number=} ReactTextFieldProps.wait
 */

/** @param {import('@material-ui/core').OutlinedTextFieldProps & ReactTextFieldProps} param0 */
const DebouncedTextField = ({
    changeHandler = noop,
    classes,
    fieldClass,
    inputLength = 0,
    label,
    labelClass,
    multiline = false,
    placeholder,
    rows = 0,
    subHeader,
    subHeaderClass,
    valueString,
    value,
    wait = 300,
    ...other
}) => {
    const debouncedChangeHandler = React.useCallback(_.debounce(changeHandler, wait), []);

    return (
        <>
            <div className={[classes.containerLabelsFullWidth, labelClass].join(' ')}>
                <Typography
                    className={[subHeaderClass, classes.subHeader].join(' ')}
                    color="textSecondary"
                >
                    {label}
                </Typography>
            </div>
            <TextField
                {...other}
                variant="outlined"
                className={[fieldClass, classes.formFields].join(' ')}
                placeholder={placeholder}
                defaultValue={value}
                onChange={({ target: { value } }) => debouncedChangeHandler(valueString, value)}
                fullWidth
                multiline={multiline}
                rows={rows}
                margin="normal"
                InputLabelProps={{
                    'aria-label': 'Name',
                }}
                inputProps={{
                    maxLength: inputLength
                }}
            />
        </>
    )
}

export default withStyles(styles)(DebouncedTextField);
